import PropertyReportsContainer from './components/property_reports_container_component'

export default angular
  .module('propertyReportsModule', [])
  .component('propertyReportsContainer', PropertyReportsContainer).name
